"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SortsController", {
    enumerable: true,
    get: function() {
        return SortsController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _PagedResponse = require("~/helpers/PagedResponse");
const _sortsservice = require("~/services/sorts.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let SortsController = class SortsController {
    async sortList(context, viewId) {
        return new _PagedResponse.PagedResponseImpl(await this.sortsService.sortList(context, {
            viewId
        }));
    }
    async sortCreate(context, viewId, body, req) {
        const sort = await this.sortsService.sortCreate(context, {
            sort: body,
            viewId,
            req
        });
        return sort;
    }
    async sortGet(context, sortId) {
        const sort = await this.sortsService.sortGet(context, {
            sortId
        });
        return sort;
    }
    async sortUpdate(context, sortId, body, req) {
        const sort = await this.sortsService.sortUpdate(context, {
            sortId,
            sort: body,
            req
        });
        return sort;
    }
    async sortDelete(context, sortId, req) {
        const sort = await this.sortsService.sortDelete(context, {
            sortId,
            req
        });
        return sort;
    }
    constructor(sortsService){
        this.sortsService = sortsService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/views/:viewId/sorts/',
        '/api/v2/meta/views/:viewId/sorts/'
    ]),
    (0, _extractidsmiddleware.Acl)('sortList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], SortsController.prototype, "sortList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/views/:viewId/sorts/',
        '/api/v2/meta/views/:viewId/sorts/'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('sortCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.SortReqType === "undefined" ? Object : _nocodbsdk.SortReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], SortsController.prototype, "sortCreate", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/sorts/:sortId',
        '/api/v2/meta/sorts/:sortId'
    ]),
    (0, _extractidsmiddleware.Acl)('sortGet'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('sortId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], SortsController.prototype, "sortGet", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/sorts/:sortId',
        '/api/v2/meta/sorts/:sortId'
    ]),
    (0, _extractidsmiddleware.Acl)('sortUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('sortId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.SortReqType === "undefined" ? Object : _nocodbsdk.SortReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], SortsController.prototype, "sortUpdate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/sorts/:sortId',
        '/api/v2/meta/sorts/:sortId'
    ]),
    (0, _extractidsmiddleware.Acl)('sortDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('sortId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], SortsController.prototype, "sortDelete", null);
SortsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _sortsservice.SortsService === "undefined" ? Object : _sortsservice.SortsService
    ])
], SortsController);
